import {Stamprubrictemporal} from './Stamprubrictemporal';

/**
 * Se utiliza esta clase para ser enviada al API, ya que no esta permitido en el API recibir una lista en el 'RequestBody'.
 */
export class StamprubrictemporalList {
  stamprubrictemporals: Stamprubrictemporal[];
}
